import { Typography } from "@cur8/maneki";
import styles from "./styles.module.sass";

export function Sangra75PilotTag() {
  return (
    <span className={styles.Sangra75PilotTag}>
      <Typography variant="eyebrow-m">Extended</Typography>
      <div className={styles.divider} />
      <Typography variant="eyebrow-m" color="subtle">
        Beta
      </Typography>
    </span>
  );
}
